import React, { useState, useEffect } from "react";
import { useGlobalContext } from "./GlobalContext";
import { Container, Accordion, Placeholder } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import ModalLicencie from "./ModalLicencie.js";
import { Timestamp } from "firebase/firestore";
import LoadingButton from "./LoadingButton.js";
import {
  onSnapshot,
  query,
  doc,
  collection
} from "firebase/firestore";
function ManagementLicences() {
  const {
    db,
    getLastLoginAt,
    getLastModifiedSynchro,
    handleShowAlert,
    handleShowConfirmation,
    handleCloseConfirmation,
  } = useGlobalContext();
  const [dynamicLicencies, setDynamicLicencies] = useState([]);
  const [dynamicUsers, setDynamicUsers] = useState([]);
  const [currentLicencieEdit, setCurrentLicencieEdit] = useState(null);
  const [modalLicencieShow, setModalLicencieShow] = useState(false);
  const [jsonData, setJsonData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastModifiedSynchro, setLastModifiedSynchro] = useState(null);
  const modifyLicencie = (licencie) => {
    setCurrentLicencieEdit(licencie);
    setModalLicencieShow(true);
  };
  const ajoutLicencie = () => {
    setCurrentLicencieEdit(null);
    setModalLicencieShow(true);
  };

  const onValid = (newLicencie) => {
    setModalLicencieShow(false);
  };

  const onCancel = () => {
    setModalLicencieShow(false);
  };

  const addIntoClub = async (user) => {
    handleShowConfirmation(
      "Intégrer au club ?",
      `Ce joueur sera proposer pour entrer dans le club`,
      "success",
      "Intégrer",
      "Annuler",
      null,
      async () => {
        await db.signalLicencie(user);
        handleCloseConfirmation();
      }
    );
  }

  const validEmail = async (user) => {
    handleShowConfirmation(
      "Valider l'email",
      `Valider l'email manuellement ? Parfois possible si l'email de confirmation n'arrive pas`,
      "success",
      "Valider",
      "Annuler",
      null,
      async () => {
        await db.updateUser(user.uid, {
          emailVerified: true
        });
        handleCloseConfirmation();
      }
    );
  }

  const onSynchroBadlevier = async () => {
    try {
      const lastModifiedSynchro = Timestamp.now();
      let comptAjout = 0;
      let comptUpdate = 0;

      for (let i = 0; i < jsonData.badlevier.length; i++) {
        const joueur = jsonData.badlevier[i];
        console.log("joueur : " + i);
        const licencieExistant = await db.getLicencieByLicenceNumber(
          joueur.licenceNumber
        );
        const nomPrenom = joueur.displayName.split(" ");
        if (licencieExistant) {
          await db.updateLicencie(licencieExistant.uid, {
            simpleLevel: joueur.level["S"],
            doubleLevel: joueur.level["D"],
            mixteLevel: joueur.level["M"],
            lastModifiedSynchro: lastModifiedSynchro,
            validated: true,
            firstName: nomPrenom[0],
            lastName: nomPrenom.slice(1).join(' '),
            displayName: licencieExistant.displayName === "" ? nomPrenom[0] : licencieExistant.displayName,
          });
          comptUpdate++;
        } else {
          const uid = "auto-generated" + Date.now();
          await db.addLicencie({
            uid: uid,
            description: "",
            email: "",
            emailVerified: false,
            firstName: nomPrenom[0],
            lastName: nomPrenom.slice(1).join(' '),
            displayName: nomPrenom[0],
            genderMale: joueur.genderMale,
            licenceNumber: joueur.licenceNumber,
            simpleLevel: joueur.level["S"],
            doubleLevel: joueur.level["D"],
            mixteLevel: joueur.level["M"],
            lastModifiedSynchro: lastModifiedSynchro,
            lastLoginAt: null,
            "porte-feuille": 0,
            keyPass: false,
            validated: true,
            photoURL: null
          });
          comptAjout++;
        }
      }
      await db.updateLastModifiedSynchro(lastModifiedSynchro);
      handleCloseConfirmation();
      handleShowAlert(
        `${comptAjout} licencié(s) ajouté(s) et ${comptUpdate} mis à jour`,
        "",
        "warning"
      );
      return true;
    } catch (error) {
      console.error("Problème dans la synchro des joueurs badlevier");
      return false;
    }
  };

  useEffect(() => {
    const q = query(collection(db.db, "clubs/badlevier/licenciés"));
    const unsubscribeLicencies = onSnapshot(q, async (querySnapshotLicencie) => {
      let retour = [];
      await Promise.all(querySnapshotLicencie.docs.map(async (doc) => {
        const licencie = doc.data();
        const licencieFindIndex = retour.findIndex(cre => cre.uid === licencie.uid);
        if (licencieFindIndex > -1) {
          retour[licencieFindIndex] = licencie;
        } else {
          retour.push(licencie);
        }
      }));
      retour = retour.sort((a, b) =>
        a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1
      )
      setDynamicLicencies([...retour]);
      setLoading(false);
    });

    const q2 = query(doc(db.db, "clubs/badlevier"));
    const unsubscribeLastModified = onSnapshot(q2, (doc) => {
      const badlevier = doc.data();
      setLastModifiedSynchro(badlevier["lastModifiedSynchro"]);
    });

    const fetchJson = async () => {
      try {
        const reponse = await fetch("./joueursBadlevier.json");
        const data = await reponse.json();
        setJsonData(data);
      } catch (error) {
        console.error(
          "Problème pour récupérer le fichier json des joueurs badlevier",
          error
        );
      }
    };

    let unsubscribeUsers = null;
    if (db.isAdmin) {
      const q3 = query(collection(db.db, "users"));
      unsubscribeUsers = onSnapshot(q3, async (querySnapshotLicencie) => {
        let retour = [];
        await Promise.all(querySnapshotLicencie.docs.map(async (doc) => {
          const user = doc.data();
          const userFindIndex = retour.findIndex(cre => cre.uid === user.uid);
          if (userFindIndex > -1) {
            retour[userFindIndex] = user;
          } else {
            retour.push(user);
          }
        }));
        retour = retour.sort((a, b) =>
          a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1
        )
        setDynamicUsers([...retour]);
      });
    }


    if (jsonData == null) {
      fetchJson();
    }

    return () => {
      unsubscribeLastModified();
      unsubscribeLicencies();
      if (db.isAdmin && unsubscribeUsers) unsubscribeUsers();
    };
  }, [jsonData, db]);

  const getLastModifiedJson = () => {
    if (jsonData === null) return "-";
    const date = new Date(jsonData.lastModified);
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const dateStr = date.toLocaleDateString("fr-FR", options);
    return dateStr;
  };

  const getLastModifiedSynchroGlobal = () => {
    const timeStamp = lastModifiedSynchro;
    if (timeStamp) {
      const date = timeStamp.toDate();
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const dateStr = date.toLocaleDateString("fr-FR", options);
      return dateStr;
    } else {
      return "-";
    }
  };

  const onValidLicencie = async (user) => {
    await db.updateLicencie(user.uid, { validated: true });
  };
  const onRefuseLicencie = async (user) => {
    await db.unsignalLicencie(user);
  };

  const usersNotValidated = dynamicUsers.filter(
    (user) => user.emailVerified === false
  ).sort((a, b) =>
    a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1
  );
  const usersValidated = dynamicUsers.filter(
    (user) => user.emailVerified
  ).sort((a, b) =>
    a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1
  );

  const licenciesNotValidated = dynamicLicencies.filter(
    (licencie) => licencie.validated === false
  ).sort((a, b) =>
    a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1
  );
  const licenciesValidatedWithConnexion = dynamicLicencies.filter(
    (licencie) =>
      licencie.validated &&
      licencie.lastLoginAt !== null
  ).sort((a, b) =>
    a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1
  );
  const licenciesValidated = dynamicLicencies.filter(
    (licencie) => licencie.validated &&
      licencie.lastLoginAt === null
  ).sort((a, b) =>
    a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1
  );

  const nblicencie = dynamicLicencies.filter(
    (licencie) =>
      licencie.validated &&
      licencie.licenceNumber !== ""
  ).length;

  return (
    <Container>
      <div
        className="section"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <LoadingButton className="btn btn-custom2" onClick={ajoutLicencie}>
            Ajouter un licencié
          </LoadingButton>
          <span
            style={{
              fontStyle: "italic",
              fontSize: "0.8em",
              marginLeft: "10px",
            }}
          >
            {loading ? <span>-</span> :
              <b>{nblicencie} licencié(s)</b>
            }
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          <LoadingButton
            className="btn btn-custom2"
            onClick={() => {
              handleShowConfirmation(
                "Synchronisation",
                `Les joueurs Badlevier manquants seront créés et tous les niveaux en simple, double et mixte seront mis à jour. Données FFBAD mis à jour le ${getLastModifiedJson()}`,
                "success",
                "Synchroniser",
                "Annuler",
                null,
                onSynchroBadlevier
              );
            }}
          >
            Synchro FFBAD
          </LoadingButton>
          <span
            style={{
              fontStyle: "italic",
              fontSize: "0.8em",
              textAlign: "right",
              marginRight: "10px",
            }}
          >
            Dernière synchro le {getLastModifiedSynchroGlobal()}
          </span>
        </div>
      </div>
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {licenciesNotValidated.length > 0 ? (
          <>
            <h5>A valider</h5>
            <Container style={{ display: "flex", flexDirection: "column" }}>
              {loading ?
                <Placeholder as="div" animation="glow" style={{ width: '100%', height: "100px", marginBottom: "10px" }} >
                  <Placeholder style={{ width: '100%', height: "100%", borderRadius: "5px" }} />
                </Placeholder>
                : licenciesNotValidated.map((user, index) => {
                  let lastLoginAt = getLastLoginAt(user);
                  return (
                    <div key={index} className="list2">
                      <div style={{ flex: "1 1 auto" }}>
                        <div className="col">
                          <span>
                            <b>{user.displayName}</b>
                          </span>
                        </div>
                        <div className="col">
                          <span>{user.email}</span>
                        </div>
                        <div className="col">
                          <label>
                            Dernière connexion
                            <span>{lastLoginAt}</span>
                          </label>
                        </div>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <LoadingButton
                          className="btn btn-custom2"
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                          onClickPromise={onValidLicencie}
                          additionalParam={[user]}
                        >
                          Valider
                        </LoadingButton>
                        <LoadingButton
                          className="btn btn-custom5"
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                          onClickPromise={onRefuseLicencie}
                          additionalParam={[user]}

                        >
                          Refuser
                        </LoadingButton>
                      </div>
                    </div>
                  );
                })}
            </Container>
          </>
        ) : null}
        {licenciesValidatedWithConnexion.length !== 0 && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
              <h5>Licenciés déjà connectés</h5>
              <span style={{ fontSize: "0.9em", fontStyle: "italic" }}>{licenciesValidatedWithConnexion.length} déjà connecté{licenciesValidatedWithConnexion.length > 1 && "s"}</span>
            </div>
            <Accordion
              defaultActiveKey="0"
              style={{ width: "100%" }}
            >
              {loading ?
                <Placeholder as="div" animation="glow" style={{ width: '100%', height: "100px", marginBottom: "10px" }} >
                  <Placeholder style={{ width: '100%', height: "100%", borderRadius: "5px" }} />
                </Placeholder>
                : licenciesValidatedWithConnexion.map((user, index) => {
                  let lastLoginAt = getLastLoginAt(user);
                  let lastModifiedSynchro = getLastModifiedSynchro(user);
                  return (
                    <Accordion.Item
                      eventKey={index}
                      key={index}
                      style={{
                        borderLeft: user.genderMale
                          ? "10px solid rgb(129 167 255)"
                          : "10px solid rgb(255 142 241)",
                        borderTopLeftRadius: "15px",
                        borderBottomLeftRadius: "15px",
                      }}
                    >
                      <Accordion.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              flex: "1 1 auto",
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                flex: "1 1 auto",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                              }}
                            >
                              <span style={{ fontSize: '0.8em' }}>
                                <b>{user.firstName + " " + user.lastName}</b>
                              </span>
                              <span style={{ fontSize: "0.8em" }}>
                                Portefeuille : <b>{user["porte-feuille"] ? user["porte-feuille"].toFixed(2) : 0} €</b>
                              </span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                              }}
                            >
                              <label
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                }}
                              >
                                N° licence
                                <span>
                                  {user.licenceNumber === ""
                                    ? "-"
                                    : user.licenceNumber}
                                </span>
                              </label>
                            </div>
                          </div>
                          <div
                            className="btn btn-custom1"
                            onClick={(e) => {
                              modifyLicencie(user);
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faPenToSquare}
                              disabled={!db.isAdmin && !db.isSecretaire}
                            />
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <label style={{}}>
                          Email{" "}
                          <span>{user.email === "" ? "-" : user.email}</span>
                        </label>
                        <label>
                          Prénom
                          <span>
                            {user.firstName === "" ? "-" : user.firstName}
                          </span>
                        </label>

                        <label>
                          Nom
                          <span>
                            {user.lastName === "" ? "-" : user.lastName}
                          </span>
                        </label>
                        <label>
                          Dernière connexion
                          <span>{lastLoginAt ? lastLoginAt : "-"}</span>
                        </label>
                        <label>
                          Niveau en simple
                          <span>{user.simpleLevel ? user.simpleLevel : "-"}</span>
                        </label>
                        <label>
                          Niveau en double
                          <span>{user.doubleLevel ? user.doubleLevel : "-"}</span>
                        </label>
                        <label>
                          Niveau en mixte
                          <span>{user.mixteLevel ? user.mixteLevel : "-"}</span>
                        </label>
                        <label>
                          Dernière mise à jour des niveaux
                          <span>
                            {lastModifiedSynchro ? lastModifiedSynchro : "-"}
                          </span>
                        </label>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </>
        )}
        {licenciesValidated.length !== 0 && (
          <>
            <div style={{ marginTop: "5px", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
              <h5>Licenciés jamais connectés</h5>
              <span style={{ fontSize: "0.9em", fontStyle: "italic" }}>{licenciesValidated.length} pas encore connecté{licenciesValidated.length > 1 && "s"}</span>
            </div>
            <Accordion
              defaultActiveKey="0"
              style={{ width: "100%" }}
            >
              {loading ?
                <Placeholder as="div" animation="glow" style={{ width: '100%', height: "100px", marginBottom: "10px" }} >
                  <Placeholder style={{ width: '100%', height: "100%", borderRadius: "5px" }} />
                </Placeholder>
                : licenciesValidated.map((user, index) => {
                  let lastLoginAt = getLastLoginAt(user);
                  let lastModifiedSynchro = getLastModifiedSynchro(user);
                  return (
                    <Accordion.Item
                      eventKey={index}
                      key={index}
                      style={{
                        borderLeft: user.genderMale
                          ? "10px solid rgb(129 167 255)"
                          : "10px solid rgb(255 142 241)",
                        borderTopLeftRadius: "15px",
                        borderBottomLeftRadius: "15px",
                      }}
                    >
                      <Accordion.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              flex: "1 1 auto",
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                flex: "1 1 auto",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                              }}
                            >
                              <span style={{ fontSize: '0.8em' }}>
                                <b>{user.firstName + " " + user.lastName}</b>
                              </span>
                              <span style={{ fontSize: "0.8em" }}>
                                Portefeuille : <b>{user["porte-feuille"] ? user["porte-feuille"].toFixed(2) : 0} €</b>
                              </span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                              }}
                            >
                              <label
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                }}
                              >
                                N° licence
                                <span>
                                  {user.licenceNumber === ""
                                    ? "-"
                                    : user.licenceNumber}
                                </span>
                              </label>
                            </div>
                          </div>
                          <div
                            className="btn btn-custom1"
                            onClick={(e) => {
                              modifyLicencie(user);
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faPenToSquare}
                              disabled={!db.isAdmin && !db.isSecretaire}
                            />
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <label >
                          Email{" "}
                          <span>{user.email === "" ? "-" : user.email}</span>
                        </label>
                        <label>
                          Prénom
                          <span>
                            {user.firstName === "" ? "-" : user.firstName}
                          </span>
                        </label>
                        <label>
                          Nom
                          <span>
                            {user.lastName === "" ? "-" : user.lastName}
                          </span>
                        </label>
                        <label>
                          Dernière connexion
                          <span>{lastLoginAt ? lastLoginAt : "-"}</span>
                        </label>
                        <label>
                          Niveau en simple
                          <span>{user.simpleLevel ? user.simpleLevel : "-"}</span>
                        </label>
                        <label>
                          Niveau en double
                          <span>{user.doubleLevel ? user.doubleLevel : "-"}</span>
                        </label>
                        <label>
                          Niveau en mixte
                          <span>{user.mixteLevel ? user.mixteLevel : "-"}</span>
                        </label>
                        <label>
                          Dernière mise à jour des niveaux
                          <span>
                            {lastModifiedSynchro ? lastModifiedSynchro : "-"}
                          </span>
                        </label>
                        <label>
                          A les clefs d'accès
                          <span>
                            {user.keyPass ? "Oui" : "Non"}
                          </span>
                        </label>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </>
        )}
        {db.isAdmin && usersValidated.length !== 0 && (
          <>
            <div style={{ marginTop: "5px", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
              <h5>Utilisateurs vérifiés</h5>
              <span style={{ fontSize: "0.9em", fontStyle: "italic" }}>{usersValidated.length} avec email vérifié{usersValidated.length > 1 && "s"}</span>
            </div>
            <Accordion
              defaultActiveKey="0"
              style={{ width: "100%" }}
            >
              {loading ?
                <Placeholder as="div" animation="glow" style={{ width: '100%', height: "100px", marginBottom: "10px" }} >
                  <Placeholder style={{ width: '100%', height: "100%", borderRadius: "5px" }} />
                </Placeholder>
                : usersValidated.map((user, index) => {
                  let lastLoginAt = getLastLoginAt(user);
                  return (
                    <Accordion.Item
                      eventKey={index}
                      key={index}
                    >
                      <Accordion.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              flex: "1 1 auto",
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                flex: "1 1 auto",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                              }}
                            >
                              <span>
                                <b>{user.displayName}</b>
                              </span>
                            </div>

                          </div>
                          <div
                            className="btn btn-custom1"
                            onClick={(e) => {
                              addIntoClub(user);
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            Intégrer au club
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <label>
                          Email{" "}
                          <span>{user.email === "" ? "-" : user.email}</span>
                        </label>
                        <label>
                          Pseudo
                          <span>
                            {user.displayName === "" ? "-" : user.displayName}
                          </span>
                        </label>
                        <label>
                          Dernière connexion
                          <span>{lastLoginAt ? lastLoginAt : "-"}</span>
                        </label>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </>
        )}
        {db.isAdmin && usersNotValidated.length !== 0 && (
          <>
            <div style={{ marginTop: "5px", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
              <h5>Utilisateurs non vérifiés</h5>
              <span style={{ fontSize: "0.9em", fontStyle: "italic" }}>{usersNotValidated.length} avec email non vérifié{usersNotValidated.length > 1 && "s"}</span>
            </div>
            <Accordion
              defaultActiveKey="0"
              style={{ width: "100%" }}
            >
              {loading ?
                <Placeholder as="div" animation="glow" style={{ width: '100%', height: "100px", marginBottom: "10px" }} >
                  <Placeholder style={{ width: '100%', height: "100%", borderRadius: "5px" }} />
                </Placeholder>
                : usersNotValidated.map((user, index) => {
                  let lastLoginAt = getLastLoginAt(user);
                  return (
                    <Accordion.Item
                      eventKey={index}
                      key={index}
                    >
                      <Accordion.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              flex: "1 1 auto",
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                flex: "1 1 auto",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                              }}
                            >
                              <span>
                                <b>{user.displayName}</b>
                              </span>
                            </div>

                          </div>
                          <div
                            className="btn btn-custom1"
                            onClick={(e) => {
                              validEmail(user);
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            Valider email
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <label>
                          Email{" "}
                          <span>{user.email === "" ? "-" : user.email}</span>
                        </label>
                        <label>
                          Pseudo
                          <span>
                            {user.displayName === "" ? "-" : user.displayName}
                          </span>
                        </label>
                        <label>
                          Dernière connexion
                          <span>{lastLoginAt ? lastLoginAt : "-"}</span>
                        </label>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </>
        )}
      </Container>
      <ModalLicencie
        show={modalLicencieShow}
        currentLicencieEdit={currentLicencieEdit}
        onHide={() => setModalLicencieShow(false)}
        onValid={onValid}
        onCancel={onCancel}
      />
    </Container>
  );
}

export default ManagementLicences;
